import { sendGet } from "../helpers";

const getDataMember = async (params, onSucces = () => {}, onError = () => {}) => {
    try {
      const res = await sendGet("/family/list-member", params);
      if (res.status === 200) {
        onSucces(res?.data);
      }
    } catch (error) {
    }
}
    const  ListMembers = {getDataMember};
    export default ListMembers;